(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lenis-scroll"] && !Shopify.designMode) return;
  try {
    // LENIS SMOOTH SCROLL
  window.lenis = new Lenis({
    lerp: 0.1,
    wheelMultiplier: 0.7,
    gestureOrientation: 'vertical',
    normalizeWheel: false,
    smoothTouch: false,
  });
  function raf(time) {
    window.lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  document.querySelectorAll('[data-lenis-start]').forEach((el) => {
    el.addEventListener('click', function () {
      window.lenis.start();
    });
  });
  document.querySelectorAll('[data-lenis-stop]').forEach((el) => {
    el.addEventListener('click', function () {
      window.lenis.stop();
    });
  });
  document.querySelectorAll('[data-lenis-toggle]').forEach((el) => {
    el.addEventListener('click', function () {
      this.classList.toggle('stop-scroll');
      if (this.classList.contains('stop-scroll')) {
        window.lenis.stop();
      } else {
        window.lenis.start();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
